import { render, staticRenderFns } from "./orderRecords.vue?vue&type=template&id=eae2de7a&scoped=true"
import script from "./orderRecords.vue?vue&type=script&lang=js"
export * from "./orderRecords.vue?vue&type=script&lang=js"
import style0 from "./orderRecords.vue?vue&type=style&index=0&id=eae2de7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae2de7a",
  null
  
)

export default component.exports